var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.864 3.4L12.28 4.816L8.408 8.688C8.336 8.76 8.232 8.8 8.128 8.8H7.28C7.056 8.8 6.88 8.624 6.88 8.4V7.552C6.88 7.448 6.92 7.344 7 7.272L10.864 3.4ZM13.48 3.048L12.632 2.2C12.472 2.04 12.224 2.04 12.064 2.2L11.384 2.88L12.8 4.296L13.48 3.616C13.64 3.456 13.64 3.2 13.48 3.048ZM12.8 12.8C12.8 13.24 12.44 13.6 12 13.6H0.8C0.36 13.6 0 13.24 0 12.8C0 12.36 0.36 12 0.8 12H1.6V6.4C1.6 4.168 3.128 2.288 5.2 1.76V1.2C5.2 0.536 5.736 0 6.4 0C7.064 0 7.6 0.536 7.6 1.2V1.76C8.256 1.928 8.856 2.232 9.368 2.632L5.752 6.248C5.448 6.552 5.28 6.952 5.28 7.376V8.8C5.28 9.68 6 10.4 6.88 10.4H8.296C8.72 10.4 9.128 10.232 9.424 9.928L11.2 8.16V12H12C12.44 12 12.8 12.36 12.8 12.8ZM4.8 14.4H8C8 15.28 7.28 16 6.4 16C5.52 16 4.8 15.28 4.8 14.4Z",
    fill: "#898989"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertEdit);
export default __webpack_public_path__ + "static/media/AlertEdit.ae4a16215d510705694b208698c7f55a.svg";
export { ForwardRef as ReactComponent };